import { isValidLocale } from "@/config/locale";

export const BACKUP_STOREFRONT_HOST = "backup.bergdorfbio.com";
export const MAIN_STOREFRONT_ORIGIN = "https://bergdorfbio.com";
export const DOMAIN_TRANSFER_PATH = "/api/checkout/domain-transfer";
export const DOMAIN_TRANSFER_START_PATH = `${DOMAIN_TRANSFER_PATH}/start`;
export const DOMAIN_TRANSFER_TARGET_HEADER = "x-storefront-domain-transfer-target";

export function isStorefrontHost(host: string | null, expected: string): boolean {
	return host?.toLowerCase() === expected || host?.toLowerCase() === `${expected}:443`;
}

/** Flight, prefetch and actions must never issue or consume a browser handoff. */
export function isBrowserDocumentRequest(request: { method: string; headers: Headers }): boolean {
	if (!["GET", "HEAD"].includes(request.method)) return false;
	const { headers } = request;
	if (
		headers.has("next-action") ||
		headers.has("rsc") ||
		headers.has("next-router-prefetch") ||
		headers.has("next-router-segment-prefetch") ||
		/prefetch/i.test(`${headers.get("purpose") ?? ""} ${headers.get("sec-purpose") ?? ""}`)
	)
		return false;
	const destination = headers.get("sec-fetch-dest");
	if (destination !== "document" && (destination || !headers.get("accept")?.includes("text/html")))
		return false;
	return true;
}

/** Browser documents only; callbacks, discovery and static resources keep their original host. */
export function isDomainTransferNavigation(request: {
	method: string;
	headers: Headers;
	nextUrl: { pathname: string };
}): boolean {
	if (!isBrowserDocumentRequest(request)) return false;
	const path = request.nextUrl.pathname;
	return (
		path === "/" ||
		(path !== "/cb" && safeStorefrontPath(path) === path && !path.split("/").at(-1)?.includes("."))
	);
}

/** Only local shop/account/checkout navigation; never an API or external target. */
export function safeStorefrontPath(value: string | null): string {
	if (!value || value.length > 2048 || !value.startsWith("/") || /[\\\r\n\0]/.test(value)) return "/";
	try {
		const url = new URL(value, MAIN_STOREFRONT_ORIGIN);
		if (url.origin !== MAIN_STOREFRONT_ORIGIN || url.hash) return "/";
		const segments = url.pathname.split("/").filter(Boolean);
		if (
			segments.length > 0 &&
			(!isValidLocale(segments[0]) ||
				(segments[1] &&
					!["eu", "us", "checkout", "account", "login", "signup", "affiliate", "admin", "vorkasse"].includes(
						segments[1],
					)))
		)
			return "/";
		return `${url.pathname}${url.search}`;
	} catch {
		return "/";
	}
}
